
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
name: "Desiginate",
components: {Group, Selector, XInput, XButton, XTextarea},
data() {
return {
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
isRole: false,
pay: [{key: 1, value: '是'}, {key: 0, value: '否'}],
needpay: 0,
payment: '',
payprice: 0,
roles: [{key: 'EXPT', value: '专家'}, {key: 'SRVP', value: '服务商'}],
rolesSrvp: [{key: 'true', value: '本公司专家'}, {key: 'false', value: '非本公司专家'}],
rolesExpt: [{key: 'company', value: '公司'}, {key: 'name', value: '姓名'}],
roleAccount: [],
roleType: this.$route.query.roleType || '',
roleid: '',
seq: this.$route.query.seq,
role: this.$route.query.role,
type: this.$route.query.type,
again: this.$route.query.again,
name: '',
reason: [{key: 'REJECT', value: '拒绝'}, {key: 'REGRET', value: '反悔'}, {
key: 'UNQUAL',
value: '不合格'
}, {key: 'TIMEOUT', value: '超时'}, {key: 'UCANCLR', value: '用户取消'}],
clean_reason: '',
clean_detail: ''
}
},
methods: {
changeSearchName() {
this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + this.name + '&offset=0&count=999&type=added', this.header).then(response => {
this.roleAccount = response.data['list']
if (this.roleAccount.length === 1) {
if (this.name !== this.roleAccount[0].value) {
this.isRole = true
}
} else {
this.isRole = true
}
})
},
changeSearchType() {
this.roleAccount = []
this.$http.get('/api/v1/experts?name=' + this.name + '&offset=0&count=20&status=AUDITED', this.header)
.then(response => {
this.roleAccount = response.data['list']
if (this.roleAccount.length === 1) {
if (this.name !== this.roleAccount[0].value) {
this.isRole = true
}
} else {
this.isRole = true
}
})
},
format(num) {
return num.toLocaleString('zh', {maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false});
},
priceChange() {
try {
this.payprice = parseFloat(this.payment).toFixed(2);
this.payment = this.format(parseFloat(this.payment))
if (isNaN(this.payment)) {
alert('请输入正确价格');
this.payment = '0.00';
this.payprice = 0;
}
if (this.payprice === '0.00') {
if (!confirm('确认该订单服务费用0元')) {
this.payment = '';
this.payprice = 0;
}
}
} catch (e) {
alert('请输入正确价格');
this.payment = '0.00';
this.payprice = 0;
}
},
designate() {
this.$http.post('/api/v1/normalrepairs/' + this.seq, {
"account": this.roleid.toString(),
"role": 'SRVP',
"needpay": this.needpay,
"payment": this.payprice
}, this.header)
.then(() => {
alert("指派成功");
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
againdesignate() {
if (!this.clean_reason) {
alert('请说明具体原因')
return
}
this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
'account': this.roleid.toString(),
'role': 'SRVP',
needpay: this.needpay,
payment: this.payprice,
reason: this.clean_reason,
detail: this.clean_detail
}, this.header).then(() => {
alert('改派成功')
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
},
designateSrvp() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
role: this.role,
account: this.roleid.toString()
}, this.header)
.then(() => {
alert('指派成功');
this.$router.push({name: 'RepairOrder', params: {isAdmin: this.role === 'ADMIN'}})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
designateEXPT() {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/assign_repair_to_assist', {
account: this.roleid.toString(),
role: this.role,
needpay: !!this.needpay,
payment: this.payprice
}, this.header).then(() => {
alert('指派成功');
if (this.role === 'EXPT') {
this.$router.push({name: 'records', query: {seq: this.seq}})
} else if (this.role === 'SRVP') {
this.$router.push({name: 'RepairSrvp', query: {seq: this.seq, role: this.role, type: this.type}})
}
});
},
cancel() {
this.$router.push({name: 'RepairSrvp', query: {seq: this.seq, role: this.role, type: this.type}})
},
cancelExpt() {
this.$router.push({name: 'records', query: {seq: this.seq}})
},
change() {
this.roleAccount = []
this.$http.get('/api/v1/agencies?company=' + this.name + '&offset=0&count=999&status=APPROVED', this.header).then(response => {
this.roleAccount = response.data['list']
if (this.roleAccount.length === 1) {
if (this.name !== this.roleAccount[0].value) {
this.isRole = true
}
} else {
this.isRole = true
}
})
},
changeType() {
this.roleAccount = []
if (this.roleType === 'true') {
this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?offset=0&count=999&type=added', this.header).then(response => {
this.roleAccount = response.data['list']
if (this.roleAccount.length === 1) {
if (this.name !== this.roleAccount[0].value) {
this.isRole = true
}
} else {
this.isRole = true
}
})
}
},
chose(item) {
this.roleid = item.userid;
this.name = this.role === 'ADMIN' ? item.detail.company : item.hasOwnProperty('detail') ? item.detail.name : item.name;
this.isRole = false;
},
}
}



// WEBPACK FOOTER //
// ./src/components/repairs/Desiginate.vue